import proj from 'ol/proj'
import extent from 'ol/extent'
import proj4 from 'proj4'

proj.setProj4(proj4)

const BBOX = [-106.66, 25.83, -93.50, 36.50]


proj4.defs('EPSG:32630', '+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs')
//proj4.defs('EPSG:32631', '+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs')
proj4.defs('EPSG:3081', '+proj=lcc +lat_1=27.41666666666667 +lat_2=34.91666666666666 +lat_0=31.16666666666667 +lon_0=-100 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs')
proj4.defs('EPSG:32614', '+proj=utm +zone=14 +datum=WGS84 +units=m +no_defs')
proj4.defs('EPSG:3042','+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs')
// proj4.defs('EPSG:25830','+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs')

/**
 * Proyecciones que podríamos usar en la App
 */
export const projection32630= proj.get('EPSG:32630')
export const projection3081 = proj.get('EPSG:3081')
//export const projection32614 = proj.get('EPSG:32614')
// export const projection25830 = proj.get('EPSG:25830')
//export const projection3042  = proj.get('EPSG:3042')

const fromLonLat32630 = proj.getTransform('EPSG:4326', projection32630)
const fromLonLat3081 = proj.getTransform('EPSG:4326', projection3081)
//const fromLonLat32614 = proj.getTransform('EPSG:4326', projection32614)
//const fromLonLat32631 = proj.getTransform('EPSG:4326', projection32631)
// const fromLonLat25830 = proj.getTransform('EPSG:4326', projection25830)


const extent32630 = extent.applyTransform(BBOX, fromLonLat32630)
const extent3081 = extent.applyTransform(BBOX, fromLonLat3081)
//const extent32614 = extent.applyTransform(BBOX, fromLonLat32614)
//const extent32631 = extent.applyTransform(BBOX, fromLonLat32631)
// const extent25830 = extent.applyTransform(BBOX, fromLonLat25830)

projection32630.setExtent(extent32630)
projection3081.setExtent(extent3081)
//projection32614.setExtent(extent32614)
//projection32631.setExtent(extent32631)
// projection25830.setExtent(extent25830)
// projection3042.setExtent(extent25830)


// WEBPACK FOOTER //
// ./src/components/projs.js